export const EXPORT_LIST_DOWNLOAD_FILE = 'EXPORT_LIST_DOWNLOAD_FILE';
export const EXPORT_LIST_RECEIVE = 'EXPORT_LIST_RECEIVE';
export const EXPORT_LIST_CLEAR = 'EXPORT_LIST_CLEAR';


export const EXPORT_FILE_CLEAR_FILE = 'EXPORT_FILE_CLEAR_FILE';
export const EXPORT_FILE_GET_FILE = 'EXPORT_FILE_GET_FILE';